export const setToken = (userToken) => {
  sessionStorage.setItem('token', JSON.stringify(userToken))
}

export const getToken = () => {
  const tokenString = sessionStorage.getItem('token')
  return JSON.parse(tokenString)
}

export const removeToken = () => {
  sessionStorage.removeItem('token')
}

export const removeRefreshToken = () => {
  sessionStorage.removeItem('refreshToken')
}

export const setRefreshToken = (refreshToken) => {
  sessionStorage.setItem('refreshToken', JSON.stringify(refreshToken))
}

export const getRefreshToken = () => {
  const tokenString = sessionStorage.getItem('refreshToken')
  return JSON.parse(tokenString)
}
